import { Box, Grid } from '@material-ui/core';
import { MerchantContract } from '@nemuru-eng/js-api-client';

import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';

import { useScreen } from '../../../../../../../hooks/useScreen';
import { CustomDivider } from '../../../../../../shared/components/CustomDivider';
import { Font } from '../../../../../../shared/components/Font';
import { Text } from '../../../../../../shared/components/Text';

interface MerchantDetailsProps {
  merchantContract: MerchantContract;
}

export const MerchantDetails = ({ merchantContract }: MerchantDetailsProps) => {
  const { isMobile } = useScreen();
  return (
    <Box pt={6}>
      <Font variant="subtitle1" color="textPrimary" className="pb-2">
        <Text tId={'MERCHANT_DATA'} />
      </Font>
      <CustomDivider />
      <Grid container spacing={isMobile ? 0 : 4}>
        <Grid item xs={12}>
          <TextFormField label={'BUSINESS_NAME'} value={merchantContract.businessName} name={'business_name'} />
          <TextFormField label={'CIF'} value={merchantContract.corporateIdNumber} name={'corporate_id_number'} />
          <TextFormField
            label={'ADDRESS'}
            value={`${merchantContract.address}, ${merchantContract.postalCode} ${merchantContract.city}, ${merchantContract.province}, ${merchantContract.country}`}
            name={'address'}
            multiline
          />
        </Grid>
      </Grid>
    </Box>
  );
};
